/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepLogBase } from './AutoTestStepLogBase';
const QualityTestLogBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['stdout', codecString],
    ['stderr', codecString],
    ['exitCode', codecNumber, 'exit_code'],
    ['timeSpend', parsers.duration, 'time_spend'],
]), AutoTestStepLogBase);
export class QualityTestLogBase extends AutoTestStepLogBase {
    static decode(input) {
        return QualityTestLogBaseParser.decode(input).map(res => new QualityTestLogBase(res));
    }
    static unsafeDecode(input) {
        return QualityTestLogBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QualityTestLogBaseParser.encode(data);
    }
    static schema() {
        return QualityTestLogBaseParser.schema();
    }
}
